import { FetchResult } from '@apollo/client/core'

export function throwGraphQLErrors<T>(res: FetchResult<T>) {
  if (res.errors) throw res.errors
  return res
}
